<template>
  <div :class="[$style.container, moveDown && $style.moveDown, disable && $style.disable]">
    <div :class="$style.tablet">
      <div :class="[$style.tabletWrapper, $style.white]">
        <div :class="$style.menuTabletHeader">
          <img src="./assets/net.svg" :class="$style.net" alt="notch">
          <div :class="$style.time">{{ this.time }}</div>
          <img src="./assets/battery.svg" :class="$style.battery" alt="rightSide">
        </div>
        <div :class="$style.tabletContent">
          <transition name="mobile-slide">
            <div v-if="!showPhoto" :key="1" :class="$style.gallery">
              <div v-for="(item, index) in data" :key="index"
                   :class="[$style.img, item.success && $style.success]"
                   :style="{ backgroundImage: `url(${item.image})` }"
                   @click="photoClick(index)"></div>
            </div>
            <div v-else>
              <share :item="data[selectedPhoto]" @success="success" @error="error" :key="2"/>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <div :class="$style.hands"></div>
  </div>
</template>
<script>
import share from './components/share/share'

export default {
  name: 'tablet',
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    accesses: {
      type: Array,
      default: () => [],
    },
    moveDown: Boolean,
    disable: Boolean,
  },
  components: { share },
  data: () => ({
    time: 0,
    showPhoto: false,
    selectedPhoto: null,
  }),
  methods: {
    updateTime() {
      const d = new Date()
      const h = (d.getHours() < 10 ? '0' : '') + d.getHours()
      const m = (d.getMinutes() < 10 ? '0' : '') + d.getMinutes()
      this.time = `${h}:${m}`
    },
    photoClick(id) {
      if (this.data[id].success) return
      this.selectedPhoto = id
      this.showPhoto = true
      this.$emit('showChat', id)
    },
    success() {
      this.showPhoto = false
      this.$emit('success', this.selectedPhoto)
      this.$emit('info', this.data[this.selectedPhoto].info)
    },
    error(title) {
      this.$emit('error', title)
    },
    init() {
      this.updateTime()
    },
  },
  mounted() {
    this.init()
  },
}
</script>
<style lang="scss" module src="./tablet.scss"></style>
